import { Address } from '@/api/types/public';
import { getAddressRules } from '@/utils/form-rule';
import { create } from 'zustand';

interface PaymentStoreState {
  addressList: Address[];
  setAddressList: (addressList: Address[]) => void;
}

export const usePaymentStore = create<PaymentStoreState>((set) => ({
  addressList: [],
  setAddressList: (addressList: Address[]) => {
    addressList.forEach((item) => {
      const rules = getAddressRules(item, []);
      item.checked = !rules;
      item.boxChecked = item.is_pobox === 1;
    });
    set({
      addressList,
    });
  },
  // 新增重置store的方法
  resetStore: () => {
    set({
      addressList: [],
    });
  },
}));
